<a id="lgview" class="btn btn-light mr-1" (click)="qfClicked()">{{title}}</a>
<a id="smview" class="btn btn-light btn-sm btn-block mb-1" (click)="qfClicked()">{{title}}</a>